import React, { useState, useEffect } from "react";
import { getTechniquesKata } from "../../../services/techniquesServices";
import ScrollIndicator from "./../../Home/ScrollIndicator";
import useScrollToTop from "../../../hooks/useScollToTop";
import { useNavigate } from "react-router-dom";

const TechniquesKata = () => {
  useScrollToTop();

  const [techniques, setTechniques] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Appel API pour récupérer les techniques de la famille Kata
    const fetchTechniquesKata = async () => {
      const fetchedTechniques = await getTechniquesKata();
      setTechniques(fetchedTechniques);
    };

    fetchTechniquesKata();
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="w-full pt-[100px] font-satoshi">
      <ScrollIndicator />
      <div
        className="w-full h-72 bg-cover bg-center"
        style={{ backgroundImage: `url('/img/diapo/slider_judo_06.webp')` }}
      ></div>
      <div className="bg-black bg-opacity-50 text-white p-4 max-w-[1280px] mx-auto">
        <p className="text-sm font-satoshi">
          <span
            onClick={() => handleNavigation("/")}
            className="text-white hover:underline cursor-pointer"
          >
            Accueil
          </span>{" "}
          &gt; Techniques &gt; Révisions pour Kata
        </p>
        <h1 className="text-2xl font-bold font-satoshi">Révisions pour Kata</h1>
      </div>

      <div className="max-w-[1280px] mx-auto p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {techniques.map((technique, index) => (
            <div
              key={technique.id || index}
              className={`overflow-hidden shadow-lg relative ${
                index % 2 === 0 ? "bg-blueprimary" : "bg-gray-800"
              } text-white`}
            >
              {/* Icône YouTube sur l'image */}
              <div
                className="absolute top-4 left-4 bg-blueprimary text-white p-2 rounded-full cursor-pointer"
                onClick={() => window.open(technique.video_url, "_blank")}
                title="Voir la vidéo sur YouTube"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-8 h-8"
                >
                  <path d="M10 15l5-3-5-3v6zm2-15C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 21.6c-5.289 0-9.6-4.311-9.6-9.6s4.311-9.6 9.6-9.6 9.6 4.311 9.6 9.6-4.311 9.6-9.6 9.6z" />
                </svg>
              </div>

              {/* Image de la technique */}
              <img
                src={technique.image1_url}
                alt={technique.nom}
                className="w-full h-96 object-cover bg-gray-200 p-2"
              />

              {/* Contenu de la technique */}
              <div className="p-4">
                <h3 className="text-lg font-semibold text-white text-satoshi">
                  {technique.nom}
                </h3>
                <div className="w-8 h-[2px] bg-white my-2"></div>
                <p className="text-sm text-gray-200">
                  <span className="text-white">Famille :</span>{" "}
                  {technique.famille || "Non spécifiée"}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechniquesKata;
